import React from 'react'

const LinkedInSVG = () => {
    return (
        <svg width="21" height="21" viewBox="0 0 21 21" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M4.7273 20.9668H0.580726V7.61394H4.7273V20.9668ZM2.65151 5.79251C1.32575 5.79251 0.25 4.69394 0.25 3.36823C0.25 2.73133 0.503016 2.12051 0.953387 1.67016C1.40376 1.2198 2.01459 0.966797 2.65151 0.966797C3.28843 0.966797 3.89927 1.2198 4.34964 1.67016C4.80001 2.12051 5.05303 2.73133 5.05303 3.36823C5.05303 4.69394 3.97728 5.79251 2.65151 5.79251ZM20.2464 20.9668H16.1091V14.4668C16.1091 12.9175 16.0777 10.9311 13.9533 10.9311C11.7976 10.9311 11.4668 12.6139 11.4668 14.3554V20.9668H7.32454V7.61394H11.3011V9.43537H11.359C11.9126 8.38608 13.2648 7.27894 15.282 7.27894C19.4785 7.27894 20.25 10.0425 20.25 13.6318V20.9668H20.2464Z" fill="white"/>
        </svg>
    )
}

export default LinkedInSVG
